export default "__VITE_ASSET__BPSWc80j__"